import apiClient from '../../config/axios';
import { setItem, removeItem } from '../../utils/storage';

export async function loginApi(username, password) {
  try {
    const response = await apiClient.post('/auth/login', { username, password });
    const { token, username: returnedUsername, userIdGuid } = response.data;

    localStorage.setItem('accessToken', token);
    setItem('virmatics_auth', { username: returnedUsername, userIdGuid });

    return { success: true };
  } catch (error) {
    console.error('[login] status:',  error.response?.status);
    console.error('[login] data:',    error.response?.data);
    console.error('[login] message:', error.message);

    if (!error.response) {
      return {
        success: false,
        error: `Network error: ${error.message}. Check that the backend is running and CORS is enabled for http://localhost:3005.`,
      };
    }

    const status = error.response.status;

    // 5xx — server crashed, never show raw Java stack traces to the user
    if (status >= 500) {
      return { success: false, error: 'Invalid username or password.' };
    }

    const message =
      error.response.data?.message ||
      error.response.data?.error ||
      'Invalid username or password.';
    return { success: false, error: message };
  }
}

export async function logoutApi() {
  const token = localStorage.getItem('accessToken');
  if (token) {
    try {
      await apiClient.post('/auth/logout', null, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch {
      // Even if the backend call fails, continue with local cleanup
    }
  }
  localStorage.removeItem('accessToken');
  removeItem('virmatics_auth');
}
